import { useContext } from 'react';

import { PairedCostAdjustmentSummaryModalContext } from './PairedCostAdjustmentSummaryModalContext.js';

export const usePairedCostAdjustmentSummaryModalContext = () =>
  useContext(PairedCostAdjustmentSummaryModalContext);
